function makeAppConfig() {
    const date = new Date();
    const year = date.getFullYear();
    const WebApiServer = window.location.href.indexOf("localhost") > 1 ? 'http://localhost:6600' : window.location.origin + '/service';
    const AppConfig = {
        brand: 'Portal Cobrança',
        productLink: '',
        user: JSON.parse(localStorage.getItem('currentUserCobranca')),
        year,
        layoutBoxed: false,               // true, false
        navCollapsed: false,              // true, false
        navBehind: false,                 // true, false
        fixedHeader: true,                // true, false
        sidebarWidth: 'middle',           // small, middle, large
        theme: 'light',                   // light, gray, dark
        colorOption: '32',                // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
        AutoCloseMobileNav: true,         // true, false. Automatically close sidenav on route change (Mobile only)
        server: WebApiServer,
        authSettings: {
            authURL: WebApiServer + '/connect/token',
            client_id: 'PortalCobrancaApi',
            client_secret: 'o457b1aa6eb86921af9ba9aba8ced103',
            scope: 'PortalCobrancaApi offline_access',
            grant_type: 'password',
            grant_type_refreshToken: 'refresh_token'
        },
        authToken: '',
        apiSwagger: window.location.href.indexOf("localhost") > 1 ? 'http://localhost:6600/docs' : 'http://portal.s5cc.com.br/service/docs',
        urlS5:'http://www.s5contactcenter.com.br/',        
        autoRefreshInterval: 300000,
        version: '1.0.0'
    };

    return AppConfig;
}

export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/config.ts